import { h, Component } from 'preact'
import { connect } from 'react-redux'

import EmailStep from './EmailStep.jsx'
import VerifyStep from './VerifyStep.jsx'
import CompleteStep from './CompleteStep.jsx'

import Busy from './Busy.jsx'
import Error from './Error.jsx'

import { getUrlParameter } from '../../../shared/etc/urlParams.js'
import { update as updateTracking } from '../state/actions/tracking.js'

import '../style/components/DemoApp.less'

class DemoApp extends Component {

	constructor(props) {
		super(props)
		this.state = {
			useVideo: false
		}
	}

	componentDidMount() {
		// Extract source parameter from URL on app initialization
		// Default to 'direct_link' if no source parameter is provided
		const source = getUrlParameter('source') || 'direct_link'
		this.props.updateTracking({ source })

		// Check if video exists
		const video = document.createElement('video')
		video.src = 'images/ui-preview.mp4'
		video.onloadeddata = () => {
			this.setState({ useVideo: true })
		}
	}

	render({ status }, { useVideo }) {

		const { busy, error, step } = status

		let content

		if (busy !== false) {
			content = <Busy busy={ busy } />
		} else if (error !== null) {
			content = <Error errorMessage={ error } />
		} else if (step === 'email') {
			content = <EmailStep />
		} else if (step === 'verify') {
			content = <VerifyStep />
		} else if (step === 'complete') {
			content = <CompleteStep />
		}

		return (
			<section class="DemoApp">
				<div class="preview-panel">
					<div class="preview-image">
						{useVideo ? (
							<video autoplay muted loop playsinline>
								<source src="images/ui-preview.mp4" type="video/mp4" />
							</video>
						) : (
							<img src="images/ui-preview.png" alt="Merlin Interface Preview" />
						)}
					</div>
				</div>
				<div class="form-panel">
					<header>
						<h1>Merlin™</h1>
						<h2>Demo Registration</h2>
					</header>
					<section class="content">
						{ content }
					</section>
					<footer></footer>
				</div>
			</section>
		)
	}
}

const mapStateToProps = state => ({
	status: state.status
})

const mapDispatchToProps = dispatch => ({
	updateTracking: (payload) => dispatch(updateTracking(payload))
})

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DemoApp)
